
import { granjaApi } from "../../api";
import { useMovimientosStore } from "../../store";
import Swal from "sweetalert2";





export const movimientosXBodegas = async({ page, termino, id }) => {
    try {
        const params = new URLSearchParams();
         params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('id',  id);

        const { data } = await granjaApi.get(`/movimientos/xbodega`, { params });
        useMovimientosStore.setState({ totalMovimientos: data.total });
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}




export const movimientoXBodegaYProducto = async({ page, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('id',  id);

        const { data } = await granjaApi.get(`/movimientos/xbodega/producto`, { params });
        useMovimientosStore.setState({ totalMovimientos: data.total });
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}  


